import Vue from 'vue'
import Router from 'vue-router'
import Page from '@/components/pages/Page'
import Admin from '@/components/admin/Admin'
import Users from '@/components/users/Users'
import Pages from '@/components/pages/Pages'
import Values from '@/components/values/Values'
import Tables from '@/components/tables/Tables'
import Bundle from '@/components/bundles/Bundle'
import Report from '@/components/reports/Report'
import Signin from '@/components/accounts/Signin'
import Library from '@/components/library/Library'
import UserEdit from '@/components/users/UserEdit'
import Bundles from '@/components/bundles/Bundles'
import Columns from '@/components/columns/Columns'
import Reports from '@/components/reports/Reports'
import Dataset from '@/components/datasets/Dataset'
import Dossier from '@/components/dossiers/Dossier'
import Account from '@/components/accounts/Account'
import PageAdmin from '@/components/pages/PageAdmin'
import Processes from '@/components/admin/Processes'
import Settings from '@/components/settings/Settings'
import Dossiers from '@/components/dossiers/Dossiers'
import Datasets from '@/components/datasets/Datasets'
import Accounts from '@/components/accounts/Accounts'
import TableCache from '@/components/admin/TableCache'
import PagesAdmin from '@/components/pages/PagesAdmin'
import MyAccount from '@/components/accounts/MyAccount'
import ShowReport from '@/components/reports/ShowReport'
import UserActivate from '@/components/users/UserActivate'
import ListBundles from '@/components/bundles/ListBundles'
import ListReports from '@/components/reports/ListReports'
import DiffDossiers from '@/components/dossiers/DiffDossiers'
import ListDossiers from '@/components/dossiers/ListDossiers'
import ForgotPassword from '@/components/accounts/ForgotPassword'
import EditLibraryItem from '@/components/library/EditLibraryItem'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/beheer',
      name: 'admin',
      component: Admin,
      meta: {
        scopes: [1]
      },
      children: [
        {
          path: 'gebruikers',
          name: 'users',
          component: Users,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'gebruikers/:id?',
          name: 'user-edit',
          component: UserEdit,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'bundels',
          name: 'bundles',
          component: Bundles,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'kolommen',
          name: 'columns',
          component: Columns,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'tabellen',
          name: 'tables',
          component: Tables,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'tabellen/:tableId/rapporten',
          name: 'list-reports',
          component: Reports,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'tabellen/:tableId/rapporten/:reportId',
          name: 'edit-report',
          component: Report,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'tabellen/:tableId/content',
          name: 'pages-admin',
          component: PagesAdmin,
          meta: {
            scopes: [1]
          },
          props: true
        },
        {
          path: 'tabellen/:tableId/content/:id',
          name: 'page-admin',
          component: PageAdmin,
          meta: {
            scopes: [1]
          },
          props: true
        },
        {
          path: 'accounts',
          name: 'accounts',
          component: Accounts,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'kwalificatiedossiers',
          name: 'list-dossiers',
          component: ListDossiers,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'kwalificatiedossiers/:nr',
          name: 'edit-dossier',
          component: Dossier,
          props: true,
          meta: {
            scopes: [1]
          }
        },
        {
          path: 'instellingen',
          name: '',
          component: Settings,
          meta: {
            scopes: [1]
          },
          children: [
            {
              path: 'cache',
              name: 'settings',
              component: TableCache,
              meta: {
                scopes: [1]
              }
            },
            {
              path: 'processen',
              name: 'processes',
              component: Processes,
              meta: {
                scopes: [1]
              }
            }
          ]
        }
      ]
    },
    {
      path: '/activeren/:activationCode',
      name: 'activate',
      component: UserActivate
    },
    {
      path: '/inloggen',
      name: 'sign-in',
      component: Signin
    },
    {
      path: '/wachtwoord-vergeten',
      name: 'forgot-password',
      component: ForgotPassword,
      props: true
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: {
        scopes: [1, 13, 6]
      },
      children: [
        {
          path: 'mijn-account',
          name: 'my-account',
          component: MyAccount,
          meta: {
            scopes: [1, 13, 6]
          }
        },
        {
          path: 'bundels',
          name: 'list-bundles',
          component: ListBundles,
          meta: {
            scopes: [1, 6]
          }
        },
        {
          path: 'bundel/:bundleId',
          name: 'bundle',
          component: Bundle,
          props: true,
          meta: {
            scopes: [1, 6]
          },
          children: [
            {
              path: 'basislijst',
              name: 'values',
              component: Values,
              meta: {
                scopes: [1, 6]
              }
            },
            {
              path: 'tabellen',
              name: 'datasets',
              component: Datasets,
              meta: {
                scopes: [1, 6]
              }
            },
            {
              path: 'tabellen/:tableId',
              name: 'dataset',
              component: Dataset,
              meta: {
                scopes: [1, 6]
              }
            },
            {
              path: 'rapporten',
              name: 'reports',
              component: ListReports,
              meta: {
                scopes: [1, 6]
              }
            },
            {
              path: 'rapporten/:id',
              name: 'show-report',
              component: ShowReport,
              meta: {
                scopes: [1, 6]
              }
            },
            {
              path: 'content',
              name: 'pages',
              component: Pages,
              meta: {
                scopes: [1, 6]
              }
            },
            {
              path: 'content/:id/:path?',
              name: 'page',
              component: Page,
              meta: {
                scopes: [1, 6]
              },
              props: true
            },
          ]
        },
        {
          path: 'kwalificatiedossiers',
          name: '',
          component: Dossiers,
          meta: {
            scopes: [1, 13]
          },
          children: [
            {
              path: '',
              name: 'dossiers',
              component: ListDossiers,
              meta: {
                scopes: [1, 13]
              }
            },
            {
              path: 'dossier/:nr',
              name: 'dossier',
              component: Dossier,
              props: true,
              meta: {
                scopes: [1, 13]
              }
            },
            {
              path: 'vergelijker/:dossiers?',
              name: 'diff-dossiers',
              component: DiffDossiers,
              meta: {
                scopes: [1, 13]
              },
              props: true
            }
          ]
        },
        {
          path: 'bibliotheek',
          name: 'library',
          component: Library,
          meta: {
            scopes: [1, 6]
          },
          props: true
        },
        {
          path: 'bibliotheek/:id',
          name: 'library.edit',
          component: EditLibraryItem,
          meta: {
            scopes: [1, 6]
          },
          props: true
        }
      ]
    },
    {
      path: '/rapportage/:accessCode',
      name: 'view-report',
      component: ShowReport
    },
    {
      path: '/publieke-content/:code/:path?',
      name: 'public-page',
      component: Page,
      props: true
    }
  ]
})
